import React from 'react';
import { LayoutGrid } from 'lucide-react';
import { Button } from './ui/button';
import { readBearerToken, clearBearerToken } from '../services/api';

// Small pill-shaped button that returns the user to the unified /panel hub.
// Only rendered if the user reached this module via /panel — detected by the
// presence of `panel_role_level` cookie OR a bearer token in localStorage/
// sessionStorage. Users who logged in directly to /vtas or /admin with the
// admin password don't see it (they don't have a hub to return to).
const cameFromHub = () => {
  if (typeof document !== 'undefined') {
    if (document.cookie.match(/(?:^|;\s*)panel_role_level=\d/)) return true;
  }
  return !!readBearerToken();
};

// Called when a downstream panel (e.g. /vtas) detects its session expired.
// If the user reached the module via the Hub, we redirect back to /panel so
// they see a single consistent login flow (instead of the module's own local
// login screen). Also clears the expired token so /panel goes back to its
// login view instead of auto-restoring a dead token.
export const redirectToHubIfFromHub = () => {
  if (!cameFromHub()) return false;
  clearBearerToken();
  try {
    if (typeof document !== 'undefined') {
      document.cookie = 'panel_role_level=; Max-Age=0; path=/; SameSite=Lax';
    }
  } catch { /* ignore */ }
  window.location.href = '/panel';
  return true;
};

export const BackToPanelButton = ({ size = 'default', className = '' }) => {
  if (!cameFromHub()) return null;
  return (
    <Button
      variant="outline"
      size={size}
      onClick={() => { window.location.href = '/panel'; }}
      className={`border-gray-700 text-gray-300 hover:bg-gray-800 ${className}`}
      data-testid="back-to-panel-btn"
      title="Volver al Panel Talengers"
    >
      <LayoutGrid className="w-4 h-4 mr-2" />
      Panel
    </Button>
  );
};

// Compact text link version for placing at the bottom of login forms and
// other tight spots where a full button would look heavy.
export const BackToPanelLink = ({ className = '' }) => {
  if (!cameFromHub()) return null;
  return (
    <button
      type="button"
      onClick={() => { window.location.href = '/panel'; }}
      className={`inline-flex items-center gap-1.5 text-xs text-gray-400 hover:text-white transition-colors ${className}`}
      data-testid="back-to-panel-link"
    >
      <LayoutGrid className="w-3 h-3" />
      Volver al Panel
    </button>
  );
};

export default BackToPanelButton;
